import { combineReducers } from "@reduxjs/toolkit";
import productReducer from "./slices/product"; // Ensure this is a default import
import userReducer from "./slices/user";
import cartReducer from "./slices/cart";
import orderReducer from "./slices/order";
import pageReducer from './slices/page';
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

const cartPersistConfig = {
  key: "cart",
  storage,
};
const userPersistConfig = {
  key: "user",
  storage,
};
const pagePersistConfig = {
  key: "page",
  storage,
};

const rootReducer = combineReducers({
  user: persistReducer(userPersistConfig, userReducer),
  product: productReducer,
  cart: persistReducer(cartPersistConfig, cartReducer),
  order: orderReducer,
  page: persistReducer(pagePersistConfig, pageReducer),
});

export default rootReducer;
